const DASHBOARD_STEP_BASE = [
  {
    element: '.step-projects-tabs',
    intro:
      'You can view All Teams on HackHub, projects you’ve created, and projects you’ve joined.'
  },
  {
    element: '.step-search',
    intro: 'The search bar allows you to search for all public projects.'
  },
  {
    element: '.step-new-project',
    intro: 'You can create your own project here.'
  },
  {
    element: '.step-deploy-project',
    intro:
      'Submitted projects will appear here. Public projects can be seen and searched by all HackHub users'
  },
  {
    element: '.done',
    intro: 'Let’s begin your HackHub experience!'
  }
];

exports.DASHBOARD_STEPS_VERIFIED = DASHBOARD_STEP_BASE;

exports.DASHBOARD_STEPS_NOT_VERIFIED = [
  {
    element: '.step-verify-email',
    intro: 'Please verify your email first.'
  }
].concat(DASHBOARD_STEP_BASE);

exports.SMALL_SCREEN = {
  WARNING: '/img/general/warning.png',
  MAIN: '/img/general/main.png'
};

exports.User = {
  defaultAvatar: '/img/user/profile.png',
  defaultNavIcon: '/img/user/profile.png',
  logoutNav: '/img/user/logout.png'
};

exports.MSG_TYPE = {
  PROJECT: 'PROJECT',
  MENTOR: 'MENTOR'
};



// WEBPACK FOOTER //
// ./src/components/nav/constant.js